/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The TermCategory model module.
* @module model/TermCategory
* @version 4.0.0
*/
export default class TermCategory {
    /**
    * Constructs a new <code>TermCategory</code>.
    * @alias module:model/TermCategory
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>TermCategory</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TermCategory} obj Optional instance to populate.
    * @return {module:model/TermCategory} The populated <code>TermCategory</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TermCategory();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('termId')) {
                obj['termId'] = ObjectID.constructFromObject(data['termId']);
            }
            if (data.hasOwnProperty('categoryId')) {
                obj['categoryId'] = ObjectID.constructFromObject(data['categoryId']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * @member {module:model/ObjectID} termId
    */
    termId = undefined;
    /**
    * @member {module:model/ObjectID} categoryId
    */
    categoryId = undefined;




}
